module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "users"
    }
  }, [_c('v-panel', {
    staticClass: "big-margin"
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [(_vm.users.length > 0) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "users"
    }
  }, [_vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "user-inner"
    }, [_c('span', {
      staticClass: "status",
      class: {
        active: user.active == '1'
      }
    }, [_vm._v(_vm._s(user.active == "1" ? _vm.$t('account.users.active') : _vm.$t('account.users.inactive')))]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
      staticClass: "avatar-wrapper"
    }, [_c('img', {
      attrs: {
        "src": user.avatar ? user.avatar : '',
        "alt": "",
        "width": "100",
        "height": "100"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(user.full_name))]), _vm._v(" "), _c('div', {
      staticClass: "role"
    }, [_vm._v(_vm._s(user.role.title))])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('div', {
      staticClass: "phone"
    }, [_vm._v(_vm._s(user.phone))])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(user.description))]), _vm._v(" "), _c('div', {
      staticClass: "edit-containt"
    }, [_c('button', {
      staticClass: "edit-users",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.edit(user.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.edit")))])])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 add-new-item"
  }, [_c('div', {
    staticClass: "user-inner"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-target": "#user-modal",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.new_user()
      }
    }
  }, [_c('span', {
    staticClass: "plus-icon-new"
  }, [_vm._v("+")])])])])], 2) : _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "150px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/users.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("account.users.index.no_result")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup ",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.new_user($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.setup")))])])])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e498650a"}!./src/app/pages/users/index/index.html
// module id = 1441
// module chunks = 0